import { ACFlag as e } from "./ACFlag.js";
import { ADFlag as t } from "./ADFlag.js";
import { AEFlag as n } from "./AEFlag.js";
import { AFFlag as r } from "./AFFlag.js";
import { AGFlag as i } from "./AGFlag.js";
import { AIFlag as a } from "./AIFlag.js";
import { ALFlag as o } from "./ALFlag.js";
import { AMFlag as s } from "./AMFlag.js";
import { AOFlag as c } from "./AOFlag.js";
import { AQFlag as l } from "./AQFlag.js";
import { ARFlag as u } from "./ARFlag.js";
import { ASFlag as d } from "./ASFlag.js";
import { ATFlag as f } from "./ATFlag.js";
import { AUFlag as p } from "./AUFlag.js";
import { AWFlag as m } from "./AWFlag.js";
import { AXFlag as h } from "./AXFlag.js";
import { AZFlag as g } from "./AZFlag.js";
import { BAFlag as _ } from "./BAFlag.js";
import { BBFlag as v } from "./BBFlag.js";
import { BDFlag as y } from "./BDFlag.js";
import { BEFlag as b } from "./BEFlag.js";
import { BFFlag as x } from "./BFFlag.js";
import { BGFlag as S } from "./BGFlag.js";
import { BHFlag as C } from "./BHFlag.js";
import { BIFlag as w } from "./BIFlag.js";
import { BJFlag as T } from "./BJFlag.js";
import { BLFlag as E } from "./BLFlag.js";
import { BMFlag as D } from "./BMFlag.js";
import { BNFlag as O } from "./BNFlag.js";
import { BOFlag as k } from "./BOFlag.js";
import { BQFlag as A } from "./BQFlag.js";
import { BRFlag as j } from "./BRFlag.js";
import { BSFlag as M } from "./BSFlag.js";
import { BTFlag as N } from "./BTFlag.js";
import { BVFlag as P } from "./BVFlag.js";
import { BWFlag as F } from "./BWFlag.js";
import { BYFlag as I } from "./BYFlag.js";
import { BZFlag as L } from "./BZFlag.js";
import { CAFlag as R } from "./CAFlag.js";
import { CCFlag as z } from "./CCFlag.js";
import { CDFlag as B } from "./CDFlag.js";
import { CFFlag as V } from "./CFFlag.js";
import { CGFlag as H } from "./CGFlag.js";
import { CHFlag as U } from "./CHFlag.js";
import { CIFlag as W } from "./CIFlag.js";
import { CKFlag as G } from "./CKFlag.js";
import { CLFlag as K } from "./CLFlag.js";
import { CMFlag as q } from "./CMFlag.js";
import { CNFlag as J } from "./CNFlag.js";
import { COFlag as Y } from "./COFlag.js";
import { CRFlag as X } from "./CRFlag.js";
import { CUFlag as Z } from "./CUFlag.js";
import { CVFlag as Q } from "./CVFlag.js";
import { CWFlag as $ } from "./CWFlag.js";
import { CXFlag as ee } from "./CXFlag.js";
import { CYFlag as te } from "./CYFlag.js";
import { CZFlag as ne } from "./CZFlag.js";
import { DEFlag as re } from "./DEFlag.js";
import { DJFlag as ie } from "./DJFlag.js";
import { DKFlag as ae } from "./DKFlag.js";
import { DMFlag as oe } from "./DMFlag.js";
import { DOFlag as se } from "./DOFlag.js";
import { DZFlag as ce } from "./DZFlag.js";
import { ECFlag as le } from "./ECFlag.js";
import { EEFlag as ue } from "./EEFlag.js";
import { EGFlag as de } from "./EGFlag.js";
import { EHFlag as fe } from "./EHFlag.js";
import { ERFlag as pe } from "./ERFlag.js";
import { ESFlag as me } from "./ESFlag.js";
import { ETFlag as he } from "./ETFlag.js";
import { EUFlag as ge } from "./EUFlag.js";
import { FIFlag as _e } from "./FIFlag.js";
import { FJFlag as ve } from "./FJFlag.js";
import { FKFlag as ye } from "./FKFlag.js";
import { FMFlag as be } from "./FMFlag.js";
import { FOFlag as xe } from "./FOFlag.js";
import { FRFlag as Se } from "./FRFlag.js";
import { GAFlag as Ce } from "./GAFlag.js";
import { GBFlag as we } from "./GBFlag.js";
import { GDFlag as Te } from "./GDFlag.js";
import { GEABFlag as Ee } from "./GEABFlag.js";
import { GEFlag as De } from "./GEFlag.js";
import { GEOSFlag as Oe } from "./GEOSFlag.js";
import { GFFlag as ke } from "./GFFlag.js";
import { GGFlag as Ae } from "./GGFlag.js";
import { GHFlag as je } from "./GHFlag.js";
import { GIFlag as Me } from "./GIFlag.js";
import { GLFlag as Ne } from "./GLFlag.js";
import { GMFlag as Pe } from "./GMFlag.js";
import { GNFlag as Fe } from "./GNFlag.js";
import { GPFlag as Ie } from "./GPFlag.js";
import { GQFlag as Le } from "./GQFlag.js";
import { GRFlag as Re } from "./GRFlag.js";
import { GSFlag as ze } from "./GSFlag.js";
import { GTFlag as Be } from "./GTFlag.js";
import { GUFlag as Ve } from "./GUFlag.js";
import { GWFlag as He } from "./GWFlag.js";
import { GYFlag as Ue } from "./GYFlag.js";
import { HKFlag as We } from "./HKFlag.js";
import { HMFlag as Ge } from "./HMFlag.js";
import { HNFlag as Ke } from "./HNFlag.js";
import { HRFlag as qe } from "./HRFlag.js";
import { HTFlag as Je } from "./HTFlag.js";
import { HUFlag as Ye } from "./HUFlag.js";
import { ICFlag as Xe } from "./ICFlag.js";
import { IDFlag as Ze } from "./IDFlag.js";
import { IEFlag as Qe } from "./IEFlag.js";
import { ILFlag as $e } from "./ILFlag.js";
import { IMFlag as et } from "./IMFlag.js";
import { INFlag as tt } from "./INFlag.js";
import { IOFlag as nt } from "./IOFlag.js";
import { IQFlag as rt } from "./IQFlag.js";
import { IRFlag as it } from "./IRFlag.js";
import { ISFlag as at } from "./ISFlag.js";
import { ITFlag as ot } from "./ITFlag.js";
import { JEFlag as st } from "./JEFlag.js";
import { JMFlag as ct } from "./JMFlag.js";
import { JOFlag as lt } from "./JOFlag.js";
import { JPFlag as ut } from "./JPFlag.js";
import { KEFlag as dt } from "./KEFlag.js";
import { KGFlag as ft } from "./KGFlag.js";
import { KHFlag as pt } from "./KHFlag.js";
import { KIFlag as mt } from "./KIFlag.js";
import { KMFlag as ht } from "./KMFlag.js";
import { KNFlag as gt } from "./KNFlag.js";
import { KPFlag as _t } from "./KPFlag.js";
import { KRFlag as vt } from "./KRFlag.js";
import { KWFlag as yt } from "./KWFlag.js";
import { KYFlag as bt } from "./KYFlag.js";
import { KZFlag as xt } from "./KZFlag.js";
import { LAFlag as St } from "./LAFlag.js";
import { LBFlag as Ct } from "./LBFlag.js";
import { LCFlag as wt } from "./LCFlag.js";
import { LIFlag as Tt } from "./LIFlag.js";
import { LKFlag as Et } from "./LKFlag.js";
import { LRFlag as Dt } from "./LRFlag.js";
import { LSFlag as Ot } from "./LSFlag.js";
import { LTFlag as kt } from "./LTFlag.js";
import { LUFlag as At } from "./LUFlag.js";
import { LVFlag as jt } from "./LVFlag.js";
import { LYFlag as Mt } from "./LYFlag.js";
import { MAFlag as Nt } from "./MAFlag.js";
import { MCFlag as Pt } from "./MCFlag.js";
import { MDFlag as Ft } from "./MDFlag.js";
import { MEFlag as It } from "./MEFlag.js";
import { MFFlag as Lt } from "./MFFlag.js";
import { MGFlag as Rt } from "./MGFlag.js";
import { MHFlag as zt } from "./MHFlag.js";
import { MKFlag as Bt } from "./MKFlag.js";
import { MLFlag as Vt } from "./MLFlag.js";
import { MMFlag as Ht } from "./MMFlag.js";
import { MNFlag as Ut } from "./MNFlag.js";
import { MOFlag as Wt } from "./MOFlag.js";
import { MPFlag as Gt } from "./MPFlag.js";
import { MQFlag as Kt } from "./MQFlag.js";
import { MRFlag as qt } from "./MRFlag.js";
import { MSFlag as Jt } from "./MSFlag.js";
import { MTFlag as Yt } from "./MTFlag.js";
import { MUFlag as Xt } from "./MUFlag.js";
import { MVFlag as Zt } from "./MVFlag.js";
import { MWFlag as Qt } from "./MWFlag.js";
import { MXFlag as $t } from "./MXFlag.js";
import { MYFlag as en } from "./MYFlag.js";
import { MZFlag as tn } from "./MZFlag.js";
import { NAFlag as nn } from "./NAFlag.js";
import { NCFlag as rn } from "./NCFlag.js";
import { NEFlag as an } from "./NEFlag.js";
import { NFFlag as on } from "./NFFlag.js";
import { NGFlag as sn } from "./NGFlag.js";
import { NIFlag as cn } from "./NIFlag.js";
import { NLFlag as ln } from "./NLFlag.js";
import { NOFlag as un } from "./NOFlag.js";
import { NPFlag as dn } from "./NPFlag.js";
import { NRFlag as fn } from "./NRFlag.js";
import { NUFlag as pn } from "./NUFlag.js";
import { NZFlag as mn } from "./NZFlag.js";
import { OMFlag as hn } from "./OMFlag.js";
import { PAFlag as gn } from "./PAFlag.js";
import { PEFlag as _n } from "./PEFlag.js";
import { PFFlag as vn } from "./PFFlag.js";
import { PGFlag as yn } from "./PGFlag.js";
import { PHFlag as bn } from "./PHFlag.js";
import { PKFlag as xn } from "./PKFlag.js";
import { PLFlag as Sn } from "./PLFlag.js";
import { PMFlag as Cn } from "./PMFlag.js";
import { PNFlag as wn } from "./PNFlag.js";
import { PRFlag as Tn } from "./PRFlag.js";
import { PSFlag as En } from "./PSFlag.js";
import { PTFlag as Dn } from "./PTFlag.js";
import { PWFlag as On } from "./PWFlag.js";
import { PYFlag as kn } from "./PYFlag.js";
import { QAFlag as An } from "./QAFlag.js";
import { REFlag as jn } from "./REFlag.js";
import { ROFlag as Mn } from "./ROFlag.js";
import { RSFlag as Nn } from "./RSFlag.js";
import { RUFlag as Pn } from "./RUFlag.js";
import { RWFlag as Fn } from "./RWFlag.js";
import { SAFlag as In } from "./SAFlag.js";
import { SBFlag as Ln } from "./SBFlag.js";
import { SCFlag as Rn } from "./SCFlag.js";
import { SDFlag as zn } from "./SDFlag.js";
import { SEFlag as Bn } from "./SEFlag.js";
import { SGFlag as Vn } from "./SGFlag.js";
import { SHFlag as Hn } from "./SHFlag.js";
import { SIFlag as Un } from "./SIFlag.js";
import { SJFlag as Wn } from "./SJFlag.js";
import { SKFlag as Gn } from "./SKFlag.js";
import { SLFlag as Kn } from "./SLFlag.js";
import { SMFlag as qn } from "./SMFlag.js";
import { SNFlag as Jn } from "./SNFlag.js";
import { SOFlag as Yn } from "./SOFlag.js";
import { SRFlag as Xn } from "./SRFlag.js";
import { SSFlag as Zn } from "./SSFlag.js";
import { STFlag as Qn } from "./STFlag.js";
import { SVFlag as $n } from "./SVFlag.js";
import { SXFlag as er } from "./SXFlag.js";
import { SYFlag as tr } from "./SYFlag.js";
import { SZFlag as nr } from "./SZFlag.js";
import { TAFlag as rr } from "./TAFlag.js";
import { TCFlag as ir } from "./TCFlag.js";
import { TDFlag as ar } from "./TDFlag.js";
import { TFFlag as or } from "./TFFlag.js";
import { TGFlag as sr } from "./TGFlag.js";
import { THFlag as cr } from "./THFlag.js";
import { TJFlag as lr } from "./TJFlag.js";
import { TKFlag as ur } from "./TKFlag.js";
import { TLFlag as dr } from "./TLFlag.js";
import { TMFlag as fr } from "./TMFlag.js";
import { TNFlag as pr } from "./TNFlag.js";
import { TOFlag as mr } from "./TOFlag.js";
import { TRFlag as hr } from "./TRFlag.js";
import { TTFlag as gr } from "./TTFlag.js";
import { TVFlag as _r } from "./TVFlag.js";
import { TWFlag as vr } from "./TWFlag.js";
import { TZFlag as yr } from "./TZFlag.js";
import { UAFlag as br } from "./UAFlag.js";
import { UGFlag as xr } from "./UGFlag.js";
import { UMFlag as Sr } from "./UMFlag.js";
import { USFlag as Cr } from "./USFlag.js";
import { UYFlag as wr } from "./UYFlag.js";
import { UZFlag as Tr } from "./UZFlag.js";
import { VAFlag as Er } from "./VAFlag.js";
import { VCFlag as Dr } from "./VCFlag.js";
import { VEFlag as Or } from "./VEFlag.js";
import { VGFlag as kr } from "./VGFlag.js";
import { VIFlag as Ar } from "./VIFlag.js";
import { VNFlag as jr } from "./VNFlag.js";
import { VUFlag as Mr } from "./VUFlag.js";
import { WFFlag as Nr } from "./WFFlag.js";
import { WSFlag as Pr } from "./WSFlag.js";
import { XKFlag as Fr } from "./XKFlag.js";
import { YEFlag as Ir } from "./YEFlag.js";
import { YTFlag as Lr } from "./YTFlag.js";
import { ZAFlag as Rr } from "./ZAFlag.js";
import { ZMFlag as zr } from "./ZMFlag.js";
import { ZWFlag as Br } from "./ZWFlag.js";
//#region src/components/flags/registry.ts
var Vr = {
	DZ: ce,
	AO: c,
	AC: e,
	BJ: T,
	BW: F,
	IO: nt,
	BF: x,
	BI: w,
	CM: q,
	IC: Xe,
	CV: Q,
	CF: V,
	TD: ar,
	KM: ht,
	CG: H,
	CD: B,
	CI: W,
	DJ: ie,
	EG: de,
	GQ: Le,
	ER: pe,
	SZ: nr,
	ET: he,
	TF: or,
	GA: Ce,
	GM: Pe,
	GH: je,
	GN: Fe,
	GW: He,
	KE: dt,
	LS: Ot,
	LR: Dt,
	LY: Mt,
	MG: Rt,
	MW: Qt,
	ML: Vt,
	MR: qt,
	MU: Xt,
	YT: Lr,
	MA: Nt,
	MZ: tn,
	NA: nn,
	NE: an,
	NG: sn,
	RW: Fn,
	RE: jn,
	SN: Jn,
	SC: Rn,
	SL: Kn,
	SO: Yn,
	ZA: Rr,
	SS: Zn,
	SH: Hn,
	SD: zn,
	ST: Qn,
	TZ: yr,
	TG: sr,
	TA: rr,
	TN: pr,
	UG: xr,
	EH: fe,
	ZM: zr,
	ZW: Br,
	AI: a,
	AG: i,
	AR: u,
	AW: m,
	BS: M,
	BB: v,
	BZ: L,
	BM: D,
	BO: k,
	BV: P,
	BR: j,
	VG: kr,
	CA: R,
	BQ: A,
	KY: bt,
	CL: K,
	CO: Y,
	CR: X,
	CU: Z,
	CW: $,
	DM: oe,
	DO: se,
	EC: le,
	SV: $n,
	FK: ye,
	GF: ke,
	GL: Ne,
	GD: Te,
	GP: Ie,
	GT: Be,
	GY: Ue,
	HT: Je,
	HN: Ke,
	JM: ct,
	MQ: Kt,
	MX: $t,
	MS: Jt,
	NI: cn,
	PA: gn,
	PY: kn,
	PE: _n,
	PR: Tn,
	SX: er,
	GS: ze,
	BL: E,
	KN: gt,
	LC: wt,
	MF: Lt,
	PM: Cn,
	VC: Dr,
	SR: Xn,
	TT: gr,
	TC: ir,
	UM: Sr,
	VI: Ar,
	US: Cr,
	UY: wr,
	VE: Or,
	"GE-AB": Ee,
	AF: r,
	AM: s,
	AZ: g,
	BH: C,
	BD: y,
	BT: N,
	BN: O,
	KH: pt,
	CN: J,
	CY: te,
	GE: De,
	HK: We,
	IN: tt,
	ID: Ze,
	IR: it,
	IQ: rt,
	IL: $e,
	JP: ut,
	JO: lt,
	KZ: xt,
	KW: yt,
	KG: ft,
	LA: St,
	LB: Ct,
	MO: Wt,
	MY: en,
	MV: Zt,
	MN: Ut,
	MM: Ht,
	NP: dn,
	KP: _t,
	OM: hn,
	PK: xn,
	PS: En,
	PH: bn,
	QA: An,
	SA: In,
	SG: Vn,
	KR: vt,
	"GE-OS": Oe,
	LK: Et,
	SY: tr,
	TW: vr,
	TJ: lr,
	TH: cr,
	TL: dr,
	TM: fr,
	TR: hr,
	AE: n,
	UZ: Tr,
	VN: jr,
	YE: Ir,
	AX: h,
	AL: o,
	AD: t,
	AT: f,
	BY: I,
	BE: b,
	BA: _,
	BG: S,
	HR: qe,
	CZ: ne,
	DK: ae,
	EE: ue,
	FO: xe,
	FI: _e,
	FR: Se,
	DE: re,
	GI: Me,
	GR: Re,
	GG: Ae,
	HU: Ye,
	IS: at,
	IE: Qe,
	IM: et,
	IT: ot,
	JE: st,
	XK: Fr,
	LV: jt,
	LI: Tt,
	LT: kt,
	LU: At,
	MT: Yt,
	MD: Ft,
	MC: Pt,
	ME: It,
	NL: ln,
	MK: Bt,
	NO: un,
	PL: Sn,
	PT: Dn,
	RO: Mn,
	RU: Pn,
	SM: qn,
	RS: Nn,
	SK: Gn,
	SI: Un,
	ES: me,
	SJ: Wn,
	SE: Bn,
	CH: U,
	UA: br,
	GB: we,
	VA: Er,
	AS: d,
	AU: p,
	CX: ee,
	CC: z,
	CK: G,
	FJ: ve,
	PF: vn,
	GU: Ve,
	HM: Ge,
	KI: mt,
	MH: zt,
	FM: be,
	NR: fn,
	NC: rn,
	NZ: mn,
	NU: pn,
	NF: on,
	MP: Gt,
	PW: On,
	PG: yn,
	PN: wn,
	WS: Pr,
	SB: Ln,
	TK: ur,
	TO: mr,
	TV: _r,
	VU: Mr,
	WF: Nr,
	AQ: l,
	EU: ge
};
//#endregion
export { Vr as flagRegistry };
